import type { UseUsersWithUniqueOrganizationParams } from '../user/_hooks/user';

export const queryKeyMap = {
  users: (params?: object) =>
    ['users', params].filter((item) => item !== undefined),
  usersLight: (params?: object) =>
    ['usersLight', params].filter((item) => item !== undefined),
  user: (id?: string) => ['user', id].filter((item) => item !== undefined),
  usersWithUniqueOrganization: (
    params?: UseUsersWithUniqueOrganizationParams,
  ) =>
    ['usersWithUniqueOrganization', params].filter(
      (item) => item !== undefined,
    ),
  userOptions: (params?: object) =>
    ['userOptions', params].filter((item) => item !== undefined),
  organizations: (params?: object) =>
    ['organizations', params].filter((item) => item !== undefined),
  organizationIdsRecursive: (ids?: string[]) =>
    ['organizationsIdsRecursive', ids].filter((item) => item !== undefined),
  organizationsNestedList: (params?: object) =>
    ['organizationsNestedList', params].filter((item) => item !== undefined),
  organizationWithUppers: (params?: object) =>
    ['organizationWithUppers', params].filter((item) => item !== undefined),
  organizationsNestedOptions: (params?: object) =>
    ['organizationsNestedOptions', params].filter((item) => item !== undefined),
  organizationsFlattenOptions: (params?: object) =>
    ['organizationsFlattenOptions', params].filter(
      (item) => item !== undefined,
    ),
  organization: (id?: string, params?: object) =>
    ['organization', id, params].filter((item) => item !== undefined),

  roles: (params?: object) =>
    ['roles', params].filter((item) => item !== undefined),
  role: (id?: string) => ['role', id].filter((item) => item !== undefined),

  hierarchyLabels: (params?: object) =>
    ['hierarchyLabels', params].filter((item) => item !== undefined),
};

export const invalidateListMap = {
  users: () => [
    queryKeyMap.users(),
    queryKeyMap.usersLight(),
    queryKeyMap.usersWithUniqueOrganization(),
    queryKeyMap.userOptions(),
  ],
  organizations: () => [
    queryKeyMap.organizations(),
    queryKeyMap.organizationIdsRecursive(),
    queryKeyMap.organizationsNestedList(),
    queryKeyMap.organizationsNestedOptions(),
    queryKeyMap.organizationsFlattenOptions(),
    queryKeyMap.organizationWithUppers(),
  ],
};
